export default __webpack_public_path__ + "static/media/vegetable_table.115736c6.png";